import * as FrontCubeData from '../../frontCubeData/index';

export function textareaSize(cubeId: string): PhysicsSize {
    return {
        width: FrontCubeData.getNumberValue(cubeId, 'width'),
        height: FrontCubeData.getNumberValue(cubeId, 'height')
    }
}
